import React, { useState, useEffect  } from 'react'
import {
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Button,
  Input,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from "react-redux";
import soundwave from '../../../images/64429-sound-wave.gif'

// LeftEditorItem2
const LeftEditorItem2 = (props) => {

  // componentDidMount
  useEffect(() => {

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _toggleEdit = () => {
    props.toggleEditMode(props.item)
  }

  return (
    <div
      style={{
      height: 24,
      width: '100%',
    }}>

      {props.item.index === props.playingBlockIndex && props.item.type === "text" && props.isPlaying === true ? (
        <div style={{
          width: 24,
          height: 24,
          float: 'left',
        }}>
          <img src={soundwave} style={{
            width: 22,
            height: 22,
          }} alt="soundwave" />
        </div>
      ) : (
        <div style={{
          width: 24,
          height: 24,
          float: 'left',
        }}>

        </div>
      )}

      <span style={{
        fontSize: 12,
      }}>
        {props.item.start}
      </span>

      {props.item.start && (
        <>

          <FontAwesomeIcon
            className={props.item.index === props.playingBlockIndex ? '' : 'demo02'}
            onClick={() => props.togglePlayMedia(props.item, false)}
            icon={props.isPlaying === true ? 'pause-circle' : 'play-circle'}
            style={{
              fontSize: 15,
              cursor: 'pointer',
              marginLeft: 10,
              marginRight: 10,
          }}/>

          <FontAwesomeIcon
            className={props.item.index === props.playingBlockIndex ? '' : 'demo02'}
            onClick={() => props.togglePlayMedia(props.item, true)}
            icon="download"
            style={{
              fontSize: 15,
              cursor: 'pointer',
              marginLeft: 10,
              marginRight: 10,
          }}/>

        </>
      )}

    </div>
  )
}

export default LeftEditorItem2
